/** Only thumbnails are cropped; original videos and uploaded posters stay intact. */
export function VideoThumbnail({ src, title }: { src: string | null; title: string }) {
  return <span className="video-clean-thumbnail"><img src={src ?? undefined} alt={title} loading="lazy" decoding="async"/></span>;
}